import {Button, List, Popover} from '@/ui-kit';
import {Download, FileOutline} from '@/ui-kit/icons';
import {prepareLabel} from './utils';
import styles from './download-file-list.module.scss';

export const DownloadFileList = ({
  data = [],
  onDownloadItemClick,
  children,
}) => {
  const onDownloadButtonClick = (index) => {
    if (onDownloadItemClick) {
      onDownloadItemClick(index);
    }
  };

  const getPopoverContent = (itemData) => (
    <div>
      {Object.keys(itemData).map((key) => (
        <div key={key} className={styles.popoverContentItem}>
          <span className={styles.popoverContentLabel}>
            {prepareLabel(key)}:{' '}
          </span>
          {itemData[key]}
        </div>
      ))}
    </div>
  );

  return (
    <List
      dataSource={data}
      renderItem={(itemData, index) => (
        <List.Item>
          <Popover
            trigger="hover"
            title="File Details"
            content={getPopoverContent({...itemData})}
            placement="top-start"
            className={styles.item}
            on
          >
            <span className={styles.fileItem}>
              <div className={styles.fileNameContainer}>
                <div>
                  <FileOutline fontSize={28} />
                </div>
                <span className={styles.fileName} role="file-label">
                  {itemData.filename}
                </span>
              </div>
              {children && children(index)}
            </span>
            <Button
              className={styles.downloadButton}
              type="link"
              leftIcon={<Download />}
              onClick={() => onDownloadButtonClick(index)}
            >
              Download
            </Button>
          </Popover>
        </List.Item>
      )}
    />
  );
};
